import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pill } from "@/components/Badges";
import { fmtDate, fmtDateTime } from "@/lib/api";

export function ReconTable({ rows, onToggle, onLabel, showClient = true }) {
  if (!rows.length) return <p className="py-10 text-center text-sm text-muted-foreground" data-testid="recon-empty">No reconstitutions.</p>;
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Order</TableHead>
            {showClient && <TableHead>Client</TableHead>}
            <TableHead>Peptide</TableHead><TableHead>Vials</TableHead><TableHead>BAC / vial</TableHead>
            <TableHead>Total BAC</TableHead><TableHead>Ordered</TableHead><TableHead>Status</TableHead>
            {(onToggle || onLabel) && <TableHead />}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={`${r.order_id}-${r.item_index}`} data-testid={`recon-row-${r.order_number}-${r.item_index}`}>
              <TableCell className="font-mono-data">{r.order_number}</TableCell>
              {showClient && <TableCell>{r.client_name}</TableCell>}
              <TableCell>{r.product_name} <span className="font-mono-data text-xs text-muted-foreground">{r.vial_size}</span></TableCell>
              <TableCell className="font-mono-data">{r.quantity}</TableCell>
              <TableCell className="font-mono-data">{r.bac_ml} mL <span className="text-xs text-muted-foreground">({r.bac_option})</span></TableCell>
              <TableCell className="font-mono-data text-sky-400">{r.total_bac_ml} mL</TableCell>
              <TableCell className="text-muted-foreground">{fmtDate(r.created_at)}</TableCell>
              <TableCell>
                {r.recon_status === "done" ? <Pill color="emerald">Done · {fmtDateTime(r.recon_done_at)}</Pill> : <Pill color="amber">Pending</Pill>}
              </TableCell>
              {(onToggle || onLabel) && (
                <TableCell>
                  <div className="flex gap-1">
                    {onLabel && <Button size="sm" variant="outline" onClick={() => onLabel(r)} data-testid={`recon-label-${r.order_number}-${r.item_index}`}>Label</Button>}
                    {onToggle && (
                      <Button size="sm" variant={r.recon_status === "done" ? "ghost" : "default"} onClick={() => onToggle(r, r.recon_status !== "done")}
                        data-testid={`recon-toggle-${r.order_number}-${r.item_index}`}>
                        {r.recon_status === "done" ? "Undo" : "Mark done"}
                      </Button>
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
